import { Spinner } from '@economic/taco';

export function LoadingBox() {
    return (
        <div className="relative bg-white w-full h-80 flex items-center justify-center">
            <Spinner />
        </div>
    );
}
